import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { LevelDwellPointByCreateRoleTime } from "../../../api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
export default {
  name: "userLevelStayByCreateRoleTime",
  components: {
    serverList: serverList,
    DataOptions: DataOptions,
    VxeTable: VxeTable
  },
  data: function data() {
    return {
      searchInfo: {
        server_id: []
      },
      timedata: [this.$moment().format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableData: [],
      tableColumn: [{
        field: "server_id",
        title: "服务器id",
        sortable: true
      }, {
        field: "role_level",
        title: "角色等级",
        sortable: true
      }, {
        field: "num",
        title: "停留人数",
        sortable: true
      }]
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.timedata[0];
              _this.searchInfo.edate = _this.timedata[1];
              _context.next = 4;
              return LevelDwellPointByCreateRoleTime(_this.searchInfo);
            case 4:
              res = _context.sent;
              if (!res.data.list || res.data.list.length == 0) {
                _this.tableData = [];
                _this.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this.tableData = res.data.list;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};